export class SelectItem<T> {
    public value!: T;
    public description!: string;

    constructor(val: T, descr: string) {
        this.value = val;
        this.description = descr;
    }
 }